export default __webpack_public_path__ + "static/media/selected-menu-line-display-none.0c68ec22.svg";